import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ModalController, Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { ResponseWebcam } from '../../model/camera.model';
import { CameraNative } from '../../native/camera.native';
import { FaceSpoofingNative, FaceSpoofingResult } from '../../native/facespoofing.native';
import { GreatdayPluginNative } from '../../native/greatday-plugin.native';

/*
	Generated class for the AvatarProvider provider.

	See https://angular.io/docs/ts/latest/guide/dependency-injection.html
	for more info on providers and Angular 2 DI.
*/
export interface ResultGetCamera {
	path: any;
	base64Image: string;
}

export interface ResultGetCameraFaceSpoofing {
	path: any;
	base64Image: string;
	faceSpoofing: FaceSpoofingResult;
}

@Injectable()
export class CameraProvider {

	constructor(
		private greatdayPluginNative: GreatdayPluginNative,
		private cameraNative: CameraNative,
		private platform: Platform,
		private camera: Camera,
		private modalCtrl: ModalController,
		private faceSpoofing: FaceSpoofingNative
	) { }

	/**
	 * Get Camera
	 * @param swapCamera android only
	 * @returns 
	 */
	async getCamera(swapCamera?: boolean): Promise<ResultGetCamera> {
		try {
			let result: ResultGetCamera = {
				path: '',
				base64Image: ''
			}

			if (this.platform.is('cordova')) {
				if (this.platform.is('android')) {
					result = await this.getCameraAndroid(swapCamera);
				} else {
					result = await this.getCameraIOS();
				}
			} else {
				result = await this.getCameraWEB();
			}

			return result
		} catch (error) {
			throw error;
		}
	}

	/**
	 * Get Camera Face Spoofing
	 * Note: FaceSpooting support only platform android
	 * @param swapCamera;
	 * @returns 
	 */
	async getCameraFaceSpoofing(swapCamera?: boolean): Promise<ResultGetCameraFaceSpoofing> {
		try {
			let camera: ResultGetCamera;
			let result: ResultGetCameraFaceSpoofing = {
				path: '',
				base64Image: '',
				faceSpoofing: {
					liveness: false,
					threshold: 0,
					message: '',
					score: 0
				}
			}

			if (this.platform.is('cordova')) {
				if (this.platform.is('android')) {
					camera = await this.getCameraAndroid(swapCamera);
					if (camera.path) {
						result.faceSpoofing = await this.faceSpoofing.detect(camera.path);
					}
				} else {
					camera = await this.getCameraIOS();
				}
			} else {
				camera = await this.getCameraWEB();
			}

			result.path = camera.path;
			result.base64Image = camera.base64Image;

			return result
		} catch (error) {
			throw error;
		}
	}

	private async getCameraAndroid(swapCamera: boolean = false) {
		let responseCamera = null;
		const result: ResultGetCamera = {
			path: '',
			base64Image: '',
		}

		if (swapCamera) {
			responseCamera = await this.greatdayPluginNative.getCameraSwap();
		} else {
			responseCamera = await (await this.greatdayPluginNative.getGDCamera()).camera;
		}

		if (!responseCamera.cancelled) {
			result.path = responseCamera.nativeURL;
			result.base64Image = responseCamera.base64Image;
		}

		return result;
	}

	/**
	 * Get Camera Device
	 * @returns;
	 */
	private async getCameraIOS() {
		let responseCamera = null;
		const result: ResultGetCamera = {
			path: '',
			base64Image: '',
		}

		const options: CameraOptions = {
			quality: 50,
			destinationType: this.camera.DestinationType.FILE_URI,
			sourceType: this.camera.PictureSourceType.CAMERA,
			allowEdit: false,
			encodingType: this.camera.EncodingType.JPEG,
			targetWidth: 500,
			targetHeight: 500,
			saveToPhotoAlbum: false,
			cameraDirection: 1,
			correctOrientation: true
		};

		responseCamera = await this.cameraNative.getCamera(options);
		if (!responseCamera.cancelled) {
			result.path = responseCamera.nativeURL;
			result.base64Image = responseCamera.base64Image;
		}

		return result;
	}

	/**
	 * Get Webcam
	 * @returns 
	 */
	private async getCameraWEB() {
		const result: ResultGetCamera = {
			path: '',
			base64Image: '',
		}

		const modal = await this.modalCtrl.create('TimeAttendanceWebcamSfgoPage');
		modal.present();

		const responseWebcam = await new Promise<ResponseWebcam>((resolve) => {
			modal.onDidDismiss((data) => resolve(data));
		});

		result.path = responseWebcam.file;
		result.base64Image = responseWebcam.base64Image;
		return result;
	}
}



// WEBPACK FOOTER //
// ./src/providers/camera/camera.provider.ts